<template>
    <div class="home">
        <div class="buttons">
            <p v-if="loggedIn">
                <span v-if="firstName">Hi, {{ firstName }}! </span>You are
                logged in.
            </p>
            <router-link class="button" v-if="!loggedIn" to="/register"
                >Become a Citizen&nbsp;Scientist</router-link
            >
            <router-link class="button" v-if="!loggedIn" to="/login"
                >Log&nbsp;In</router-link
            >
        </div>
    </div>
</template>

<script>
import { authComputed } from '../vuex/helpers.js'

export default {
    data() {
        return {
            firstName: ''
        }
    },
    created() {
        const user = this.$store.state.user
        if (user) this.firstName = user.firstName
    },
    computed: {
        ...authComputed
    },
    methods: {
        logout() {
            this.$store.dispatch('logout')
        }
    }
}
</script>
